import * as firebase from 'firebase'
import * as React from 'react';
import { BrowserRouter as Router, NavLink, Route, RouteComponentProps } from 'react-router-dom';
import './App.css';
import Home from './components/Home'
import NodeView from './components/NodeView';
import Profile from './components/Profile';
import RegistrationFlow from './components/Register';
import TreeEdit from './components/TreeEdit';
import TreeView from './components/TreeView';
import config from './config';
import { findNode } from './domain/factories';
import { INode } from './domain/model';
import { testModel } from './services/util';

firebase.initializeApp(config.firebase);

interface IAppState {
  nodes: INode[],
  user?: firebase.User,
  profile: any,
  trees: any[]
}

function NodeMissing() {
  return (<div>Uh oh! this node has gone missing..</div>)
}

class App extends React.Component<any, IAppState, any> {

  public state: IAppState = {
    nodes: [],
    profile: undefined,
    trees: [],
    user: undefined,
  }

  public componentDidMount() {
    // Handle user authentication state!
    firebase.auth().onAuthStateChanged(state => {
      if (state) {
        console.log('auth state changed to ', state.uid, state.displayName)
        this.setState({ user: state })
        const docPath = `/users/${state.uid}`
        firebase.firestore().doc(docPath)
          .onSnapshot(profile => {
            this.setState({ profile: profile.data() })
          });

        // get active tree for user...
        const path = `/trees/${state.uid}`
        firebase.firestore().doc(path)
          .onSnapshot(doc => {
            const data = doc.data()
            if (data) {
              console.log('loaded new decision tree', data)
              this.setState({ nodes: data.nodes });
            }
          })
      } else {
        this.setState({ user: undefined })
      }

      firebase.firestore().collection(`/trees`)
        .orderBy('edited', 'desc')
        .limit(5)
        .onSnapshot(doc => {
          const trees: any[] = []
          doc.forEach(val => {
            trees.push(val.data());
          });
          this.setState({ trees })
        })
    })
    this.setState({ nodes: testModel })
  }

  public render() {
    if (!this.state.user) {
      const loginGoogle = () => this.loginGoogle();
      const loginAnon = () => this.loginAnonymously();
      return (<RegistrationFlow onGoogleLogin={loginGoogle} onAnonymousLogin={loginAnon} />)
    }
    const viewNode = (params: RouteComponentProps) => {
      const param = (params.match.params as any).nodename
      const nodeModel = findNode(this.state.nodes, param)
      if (nodeModel) {
        return (<NodeView context={this.state.nodes} node={nodeModel} />)
      } else {
        return <NodeMissing />
      }
    }

    const renderJson = (params: RouteComponentProps) => (<pre>{JSON.stringify(params.match, null, '  ')}</pre>)
    const renderTree = () => (<TreeView context={this.state.nodes} />)

    const editTree = () => {
      const hte = (c: INode[]) => this.handleTreeEdit(c);
      return <TreeEdit onSave={hte} context={this.state.nodes} />
    }

    const onLogout = () => this.logout();
    const renderProfile = () => {
      const user = this.state.user;
      if (user) {
        return (<Profile user={user} profile={this.state.profile} onLogout={onLogout} />);
      } else {
        return (<span>No user logged in</span>);
      }
    }

    const renderHome = () => {
      return (<Home trees={this.state.trees}/>)
    }


    return (
      <Router>
        <div>
          <nav>
            <NavLink exact={true} to="/">Home</NavLink>
            <NavLink to="/tree">Tree View</NavLink>
            <NavLink to="/profile">Profile</NavLink>
          </nav>
          <Route path="/" render={renderHome} exact={true} />

          <Route path="/profile" render={renderProfile} />
          <Route exact={true} path="/n/:nodename" render={viewNode} />
          <Route path="/n/:nodename/edit" render={renderJson} />
          <Route path="/tree/edit" render={editTree} />
          
          <Route exact={true} path="/tree" render={renderTree} />
        </div>
      </Router>
    );
  }
  private logout(): any {
    if (this.state.user) {
      firebase.auth().signOut()
    }
  }
  private handleTreeEdit(context: INode[]) {
    console.log('update nodes context')
    this.setState({ nodes: context })
    const uid = this.state.user ? this.state.user.uid : 'none'
    const path = `/trees/${uid}`
    firebase.firestore().doc(path)
      .set({
        edited: new Date(),
        nodes: context,
        owner: uid,
      })
      .then(() => {
        console.log('peristed thing');
      })
      .catch(err => {
        console.log('must be an error or something...', err);
      })

  }

  private loginGoogle() {
    firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  private loginAnonymously() {
    firebase.auth().signInAnonymously()
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx